import katex from 'katex';
import 'katex/mhchem';
import 'br-katex-macros';
import 'br-katex-siunitx';
import latexregex from 'br-katex-latexregex';
import katexOpts from 'br-katex-options';
import autoRender from 'katex/auto-render';

export default function renderMathInElement(element) {
  const options = katexOpts.inline;
  Object.assign(options, {
    delimiters: [
      { left: '\\(', right: '\\)', display: false },
      //  \[…\] must come last in this array, according to KaTeX auto-render docs.
      { left: '\\[', right: '\\]', display: true },
    ],

    ignoredTags: ['script', 'noscript', 'style', 'textarea', 'pre', 'code'],
    ignoredClasses: [],

    preProcess: latexregex.replace,

    errorCallback: console.error, // eslint-disable-line no-console
  });

  autoRender(element, options);
}

export function renderExpressionIntoElement(expression, element) {
  katex.render(latexregex.replace(expression), element, katexOpts.inline);
}
